import EventAnalytics from "./EventAnalytics";

export default {
  title: "EventAnalytics",
  component: EventAnalytics,
  tags: ["autodocs"],
  argTypes: {},
};

export const Primary = {
  args: {
    // events: { clickEnabled: true },
  },
};
